import { EMPTY_OFFER_REQUEST_FILTERS, type OfferRequestFiltersValue } from './types';

function isSet(value: OfferRequestFiltersValue[keyof OfferRequestFiltersValue]): boolean {
    return Array.isArray(value) ? value.length > 0 : value !== undefined && value !== '';
}

// The filters that went from unset to set. A filter counts once when it is taken into use, not on every keystroke
// of a search or every extra option ticked in it.
export function newlyUsedFilters(previous: OfferRequestFiltersValue, next: OfferRequestFiltersValue): string[] {
    return (Object.keys(EMPTY_OFFER_REQUEST_FILTERS) as (keyof OfferRequestFiltersValue)[]).filter(
        (filter) => !isSet(previous[filter]) && isSet(next[filter]),
    );
}
